import React, { Component } from 'react';

class PurchaseConfirmed extends Component {
  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Congratulations and welcome to Wreckfinder Premium!</h2>
          <p className="lead">You can now access your premium account via our mobile apps or the website.</p>
          <p>If you need any help please visit <a href="https://wreckfinder.zendesk.com/hc/en-us">our support page</a></p>
        </div>
      </LayoutWrapper>
    );
  }
}

export default PurchaseConfirmed;



// WEBPACK FOOTER //
// ./src/pages/purchase_confirmed.js